var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48343(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.638,
    height: 392.51,
    viewBox: "0 0 206.638 392.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.773,
    y1: -0.484,
    x2: 15.938,
    y2: 6.012,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.81,
    y1: 0.5,
    x2: 71.81,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 21.585,
    y1: 0.946,
    x2: 22.253,
    y2: 0.099,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 82.012,
    y1: 0.5,
    x2: 83.012,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15.133,
    y1: 0.917,
    x2: 15.603,
    y2: 0.085,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 6.313,
    y1: 2.511,
    x2: 5.441,
    y2: 3.915,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 15.631,
    y1: 5.741,
    x2: 13.442,
    y2: 9.325,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -34.372,
    y1: -72.928,
    x2: -32.356,
    y2: -75.248,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -234.944,
    y1: 146.722,
    x2: -238.834,
    y2: 135.971,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -254.958,
    y1: -8.021,
    x2: -255.616,
    y2: -7.667,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48343",
    "data-name": "Group 48343",
    transform: "translate(-881.827 -953.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48340",
    "data-name": "Group 48340",
    transform: "translate(881.827 953.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39126",
    "data-name": "Path 39126",
    d: "M1006.63,1489.255s-1.363,7.714-2.031,15.349a5.26,5.26,0,0,0,5.033,5.7c10.168.424,31.918,1.247,39.723.9a1.711,1.711,0,0,0,1.506-2.345h0a3.832,3.832,0,0,0-1.959-2.065l-35.927-16.512Z",
    transform: "translate(-919.827 -1119.582)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39127",
    "data-name": "Path 39127",
    d: "M1005.933,1482.052l1.094,9.226s6.294,2.93,10.592-.369l-2.606-10.281Z",
    transform: "translate(-920.246 -1116.911)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39128",
    "data-name": "Path 39128",
    d: "M994.332,1231.461c-.473,2.41-2.538,120.233,10.056,173.035a1.792,1.792,0,0,1-1.052,2.084,31.214,31.214,0,0,1-10.257,2.084,3.087,3.087,0,0,1-3.062-2.215c-3.6-12.251-20.851-73.631-23.1-132.264-2.515-65.517,0-2.23,0-2.23l1.475-40.5Z",
    transform: "translate(-907.822 -1039.776)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39129",
    "data-name": "Path 39129",
    d: "M945.749,1495.083s-2.169,3.894-4.269,14.242a3.21,3.21,0,0,0,2.824,3.844c3.358.33,8.526.755,12.667.726a3.2,3.2,0,0,0,3.168-3.569c-.458-3.777-1.888-9.974-6.3-14.8Z",
    transform: "translate(-900.273 -1121.386)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39130",
    "data-name": "Path 39130",
    d: "M944.932,1477.653l2.558,13.952s2.529,1.881,7.532.518l-1.221-15.012Z",
    transform: "translate(-901.362 -1115.823)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39131",
    "data-name": "Path 39131",
    d: "M933.146,1233.776c-10.3,62.165,2.235,153.646,6.463,171.552a2.791,2.791,0,0,0,2.254,2.12,18.742,18.742,0,0,0,8.057-.321,2.56,2.56,0,0,0,1.84-2.356c.567-14.476-.454-103.343,9.144-138.463a7.975,7.975,0,0,1,3.077-4.4l18.629-13.244,1.428-21.407Z",
    transform: "translate(-896.486 -1038.476)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48337",
    "data-name": "Group 48337",
    transform: "translate(32.814 29.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39132",
    "data-name": "Path 39132",
    d: "M998.836,1063.833c-30.869-.51-64.929,8.105-64.929,8.105-9.2,53.69-1.609,115.618-1.609,115.618,23.9,6.267,50.857-3.832,50.857-3.832,3.972-22.441,22.5-85.6,22.5-85.6a101.679,101.679,0,0,0,37.739-11.976c-7.8-9.047-11.484-20.558-13.082-27.363C1019.4,1062.179,1008.357,1063.991,998.836,1063.833Z",
    transform: "translate(-929.353 -1016.025)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39133",
    "data-name": "Path 39133",
    d: "M1135.285,999.192a5.9,5.9,0,0,0-6.87-1.93c-4.543,19.189-28.362,34.747-52.832,42.352,1.6,6.8,5.277,18.317,13.082,27.363C1129.276,1044.144,1135.285,999.192,1135.285,999.192Z",
    transform: "translate(-974.621 -996.853)",
    fill: "#ffc2bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48338",
    "data-name": "Group 48338",
    transform: "translate(186.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39134",
    "data-name": "Path 39134",
    d: "M1158.237,986.806c.318,1.009-3.357,2.545-5.52-1.58-.076-1.977-1.278-10.448-.1-12.059,6.293-8.579,18.492-19.333,18.492-19.333a2.9,2.9,0,0,1,.363,4.033l-5.918,6.166c1.238,2.237,2.747,4.125,3.455,6.831a8.29,8.29,0,0,1-.826,6.1c-1.039,1.872-2.457,4.3-3.8,6.208A8.19,8.19,0,0,1,1158.237,986.806Z",
    transform: "translate(-1152.103 -953.834)",
    fill: "#ffc2bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39135",
    "data-name": "Path 39135",
    d: "M1164.663,974.4l-5.393,4.572-1.693,4.551,4.808,5.335s1.617-9.032,2.818-10.987S1165.782,974.971,1164.663,974.4Z",
    transform: "translate(-1153.798 -960.2)",
    fill: "#feb3b1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39136",
    "data-name": "Path 39136",
    d: "M932.733,1107.726l-11.84-29.891s-28.834,19.591-33.576,44.431a65.587,65.587,0,0,1,24.286,6.809C915.983,1119.221,932.733,1107.726,932.733,1107.726Z",
    transform: "translate(-883.527 -992.22)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39137",
    "data-name": "Path 39137",
    d: "M980.272,1029.8l-9.822,28.4a1.022,1.022,0,0,0,.467,1.232c2.677,1.48,12.323,5.76,23.948-1.611a4.817,4.817,0,0,0,2.219-3.442l3.181-24.584Z",
    transform: "translate(-909.244 -977.35)",
    fill: "#ffc2bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48339",
    "data-name": "Group 48339",
    transform: "translate(52.387 11.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39138",
    "data-name": "Path 39138",
    d: "M1004.368,991.7s10.785,20.3,9.4,28.5-14.75,7.613-26.423.951l-8.156-21.923Z",
    transform: "translate(-964.355 -976.94)",
    fill: "#ffc2bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39139",
    "data-name": "Path 39139",
    d: "M981.212,1003.773a.837.837,0,0,0,.365-1.225,21.832,21.832,0,0,1-3-6.371s-1.939-1.241,4.935-2.887,17.125-4.2,19.28-10.05c2.1-5.7-3.419-20.05-12.225-8.62a.836.836,0,0,1-1.326.009c-1.444-1.878-5.239-5.778-10.508-3.414-4.93,2.213-5.486,5.826-5.419,7.647a.831.831,0,0,1-.985.851c-2.493-.475-8.476-.884-11.268,5.254-2.3,5.055-.805,7.917.556,9.316a.834.834,0,0,1-.357,1.385c-1.638.5-3.754,1.891-3.542,5.729.293,5.307,6.226,4.84,7.915,4.6a.839.839,0,0,1,.743.263c1.449,1.6,7.975,8.409,15.038,9.229a.844.844,0,0,0,.885-1.115l-3.057-8.885a.84.84,0,0,1,.454-1.042Z",
    transform: "translate(-957.703 -970.321)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39140",
    "data-name": "Path 39140",
    d: "M989.825,1019.428s-7.68-5.269-8.241-.832,6.915,6.427,10.619,4.773Z",
    transform: "translate(-965.086 -984.715)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39141",
    "data-name": "Path 39141",
    d: "M885.818,1141.894s-19.707,44.889,28.466,51.457l6.569-5.474s-24.086-13.138-10.948-39.413C909.9,1148.464,895.672,1136.421,885.818,1141.894Z",
    transform: "translate(-881.827 -1011.609)",
    fill: "#ffc2bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48342",
    "data-name": "Group 48342",
    transform: "translate(913.082 1107.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48341",
    "data-name": "Group 48341",
    transform: "translate(4.099 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39142",
    "data-name": "Path 39142",
    d: "M936.266,1176.726l16.962,5.714c2.053.617,3.469,2.691,3.632,5.327l-.88,28.305c.276,4.428-3.38,8.332-6.832,7.3l-13.6-4.633a3.49,3.49,0,0,1-2.217-3.5l-.3-35.242C933.016,1177.951,934.7,1176.256,936.266,1176.726Z",
    transform: "translate(-933.033 -1176.647)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39143",
    "data-name": "Path 39143",
    d: "M930.041,1214.133c-.458-.507-3.628-6.308-2.811-14.07s-.7-11.264,2.92-10.963,6.611.911,6.2,4.728S937.083,1221.918,930.041,1214.133Z",
    transform: "translate(-927.096 -1180.496)",
    fill: "#ffc2bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48343);
export default __webpack_public_path__ + "static/media/Group 48343.4d38d6fb4fdba677172045432bbf2168.svg";
export { ForwardRef as ReactComponent };